import { type InputHTMLAttributes, useRef } from "react";
import _ from "lodash";
import styles from "./Checkbox.module.css";
import Tooltip from "./Tooltip";

interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: JSX.Element | string;
  checked?: boolean;
  className?: string;
  position?: "right" | "left";
  showPointer?: boolean;
  indeterminate?: string;
  tooltip?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  position = "left",
  className,
  label,
  onClick,
  showPointer = false,
  ...rest
}) => {
  const ref = useRef<HTMLInputElement>(null);
  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    switch (e.key) {
      case " ":
        e.preventDefault();
        ref.current?.click();
        break;
      default:
        break;
    }
  };

  const _id = rest.id ?? _.uniqueId("checkbox_");
  const inputEl = (
    <Tooltip
      disabled={!rest.tooltip}
      trigger={
        <input
          ref={ref}
          type="checkbox"
          onClick={onClick}
          className={`${styles.input} ${showPointer ? "cursor-pointer" : ""}`}
          {...rest}
          id={_id}
          tabIndex={-1}
        />
      }
    >
      {rest.tooltip}
    </Tooltip>
  );
  return (
    <div
      className={`${styles.container} ${className ?? ""} ${
        showPointer ? "cursor-pointer" : ``
      }`}
      tabIndex={rest.tabIndex ?? 0}
      onKeyDown={handleKeyDown}
    >
      {position === "left" && <div className={"mr-ds-2 flex"}>{inputEl}</div>}
      <label
        htmlFor={_id}
        className={`${styles.label} ${showPointer ? "cursor-pointer" : ""}`}
      >
        {label}
      </label>
      {position === "right" && <div className={"ml-ds-2 flex"}>{inputEl}</div>}
    </div>
  );
};
export default Checkbox;
